import { render } from "./PayoutBreakdownRecord.vue?vue&type=template&id=35d5d79c&scoped=true"
import script from "./PayoutBreakdownRecord.vue?vue&type=script&lang=js"
export * from "./PayoutBreakdownRecord.vue?vue&type=script&lang=js"

import "./PayoutBreakdownRecord.vue?vue&type=style&index=0&id=35d5d79c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d5d79c"]])

export default __exports__